<template lang="pug">
  .add-vehicle-asset
    button.button.small(@click="addEnabled = !addEnabled") Add Vehicle

    .content(v-if="addEnabled")
      .close-button(@click="addEnabled = false") x
      label Booking Mode
        BookingModeSelect(v-model="bookingMode")
      label Select Vehicle
        selectize-available-vehicle-slot(@optionSelected="selected")
      button.button(:class="{disabled:!itemSelected || !bookingMode}", @click="add") Add
</template>

<script>
  import ModalReveal from '../../../foundation/ModalReveal'
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../../maggieHelper'
  import SelectizeVehicle from '../../lists/selectize/SelectizeVehicle'
  import SelectizeVehicleSlot from '../../lists/selectize/SelectizeVehicleSlot'
  import SelectizeAvailableVehicleSlot from '../../lists/selectize/SelectizeAvailableVehicleSlot'
  import BookingModeSelect from '../../../BookingModeSelect'

  export default {
    name: 'AddVehicleAsset',
    components: {BookingModeSelect, SelectizeAvailableVehicleSlot, SelectizeVehicleSlot, SelectizeVehicle, ModalReveal},
    props: ['item'],
    data() {
      return {
        itemSelected: null,
        bookingMode: 'RT',
        addEnabled: false
      }
    },
    methods: {
      selected(item) {
        this.itemSelected = item
      },
      add() {
        var body = {
          'vehicle_id': this.itemSelected.id,
          'booking_mode': this.bookingMode,
          'parking_slot_id': this.item.id,
          'name': `${this.item.name}-${this.itemSelected.model} ${this.itemSelected.plate}`
        }
        KeplerBackofficeSdk.vehicleSlots.make(body, (data) => {
          MaggieHelper.notification('add-esit', 'Vehicle Added')
          this.$emit('addVehicleAsset')
          this.addEnabled = false
        })


      }
    }
  }
</script>

<style lang="sass">
  .add-vehicle-asset
    .content
      position: absolute
      left: 0
      right: 0
      top: 0
      height: 100%
      width: 80%
      margin: 0 auto
      background: white
      display: flex
      justify-content: center
      flex-direction: column
</style>



// WEBPACK FOOTER //
// AddVehicleAsset.vue?6b841756